import { z } from "zod"

const configSchema = z.object({
  SENTRY_REPLAYS_SAMPLE_RATE: z.coerce.number().min(0).max(1).default(1),
  PUBLIC_API_BASE_URL: z.url(),
})

export const config = configSchema.parse(window.PUBLIC_APP_CONFIG)
